import React, { FC, useEffect } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface FormInputCheckboxProps {
  name: string;
  label: string | JSX.Element;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  icon?: React.ReactNode;
}

const defaultProps = {
  onChange: undefined,
  defaultChecked: false,
  icon: undefined,
};

export const FormInputCheckbox: FC<FormInputCheckboxProps> = ({ name, label, onChange, icon, defaultChecked }) => {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    setValue(name, defaultChecked);
  }, [defaultChecked]);

  return (
    <FormControlLabel
      className="input input__checkbox"
      control={
        <Controller
          name={name}
          control={control}
          defaultValue
          render={({ field: { onChange: onCheckChange, value } }) => {
            return (
              <Checkbox
                checked={!!value}
                onChange={(event) => {
                  onCheckChange(event);
                  if (onChange) {
                    onChange(event.target.checked);
                  }
                }}
                size="small"
                icon={icon}
              />
            );
          }}
        />
      }
      label={label}
    />
  );
};

FormInputCheckbox.defaultProps = defaultProps;
